import * as actions from './actions';
import * as getters from './getters';
import { mutations, state } from './mutations';

export default {
  actions,
  getters,
  mutations,
  state,
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/jump/index.js
 **/